module.exports = __webpack_public_path__ + "img/city2.e5f3e506.png";